import Flickity from 'flickity';

export default function initSlider() {

	const sliders = document.querySelectorAll('.gallery-slider');

	sliders.forEach( (item) => {
		const flkty = new Flickity( item, {
			contain: true,
			pageDots: false,
			wrapAround: true,
			lazyLoad: true,
			prevNextButtons: true,
			on: {
				ready: function(){
					window.dispatchEvent(new Event('accordion_open'));
				}
			}
		});
		window.addEventListener("accordion_open", (event) => {
			// console.log('disp');
			setTimeout(function(){
				flkty.resize();
			}, 1)
		});
	});

}